import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll-to-bottom"
//
// 要素を最下部までスクロールする。
// チャットメッセージ一覧を開いた際や、メッセージ送信後に Turbo Stream で
// 再描画された際に、最新メッセージが表示されるよう最下部へスクロールする。
export default class extends Controller {
  connect() {
    this.scrollToBottom()
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
